import { assignNamespace } from "../../common/namespace-utils";
import { o_util } from "../../common/namespaces";
import * as mappers from "./head/mappers.js";
import * as reactive from "./head/reactive.js";
import { fetchOnexData, transformAndAssignOnexData } from "./head/fragment.js";
import { otto } from "../../exports/nexus.js";

export * from "./head/mappers.js";
export * from "./head/reactive.js";

assignNamespace(
  o_util,
  "onex",
  {
    isOnexVariant: mappers.isOnexVariant,
    mapOnexVariant: mappers.mapOnexVariant,
    withOnex: mappers.withOnex,
    customAssignments: mappers.customAssignments,
    onexVariant: reactive.onexVariant,
    onexValue: reactive.onexValue,
    onexVariantByToggle: reactive.onexVariantByToggle,
  },
  {
    isOnexGroup: mappers.isOnexVariant,
    mapOnexGroup: mappers.mapOnexVariant,
  },
);

/*                                                                             */
otto.onex.assignments.set(transformAndAssignOnexData());

/*                                                                  */
if (import.meta.env.MODE !== "test") fetchOnexData();
